import { render, staticRenderFns } from "./realEstate.vue?vue&type=template&id=a229ae6a&scoped=true&"
import script from "./realEstate.vue?vue&type=script&lang=js&"
export * from "./realEstate.vue?vue&type=script&lang=js&"
import style0 from "./realEstate.vue?vue&type=style&index=0&id=a229ae6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a229ae6a",
  null
  
)

export default component.exports